import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/referral/page.tsx");
